import React from 'react'
import Close from '@mui/icons-material/Close'
import { IconButton, Stack, Typography } from '@mui/material'

interface ITextContentProps {
  onClose?: () => void
}

const TextContent: React.FC<ITextContentProps> = ({ onClose }) => {
  return (
    <Stack
      spacing={5}
      flex="1"
      alignItems="left"
      sx={{
        backgroundColor: 'bw.white',
        border: '1px solid',
        borderColor: 'bw.greyLightest',
        borderRadius: (theme) => theme.shape.borderRadius / 8,
        padding: (theme) => theme.spacing(10),
        position: 'relative',
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', right: 0, top: 0 }}
      >
        <Close />
      </IconButton>
      <Typography textAlign="left" component="div">
        <strong>To verify a card:</strong>
        <ol style={{ paddingLeft: '20px' }}>
          <li>Enter the cardholder&lsquo;s last name</li>
          <li>Enter at least one identifier — either the registration number, National Insurance number, or both</li>
          <li>Click <strong>Verify</strong></li>
        </ol>
      </Typography>
      <Typography textAlign="left">
        If successful, the cardholder&lsquo;s information will be displayed.
      </Typography>
    </Stack>
  )
}

export default TextContent
